import React from 'react'

import { Divider, Button, Col, Row, Table, Form } from '_zari/core'

import { EstadosOSE } from 'constants/index'

import * as FacturacionHistorialService from 'services/facturacionHistorial.service'

import * as FormGroups from './formGroups'
import ConfirmacionModal from './modals/confirmacion'

const ResumenDiarioTab = () => {
  const [fecha, setFecha] = React.useState('')

  const [seleccionarTodos, setSeleccionarTodos] = React.useState('')
  const [documentos, setDocumentos] = React.useState([])
  const [mostrarConfirmacionModal, setMostrarConfirmacionModal] = React.useState(false)

  const clickConsultarHandler = () => {
    // if (!fecha) {
    //   return
    // }

    FacturacionHistorialService.obtenerAsEmisorResumenSoloProcesadas({
      fecha
    }).then(({ data }) => {
      setDocumentos(data)
    })
    // setMostrarAlerta(true)
  }

  const seleccionarTodosClick = () => {
    setSeleccionarTodos(prevChecked => {
      setDocumentos(prev => {
        return prev.map(x => ({
          ...x,
          checked: !prevChecked
        }))
      })

      return !prevChecked
    })
  }

  const enviarAOSEClick = () => {
    // docIdRef.current = _id
    setMostrarConfirmacionModal(true)
  }

  const checkDocumentoChange = ({ e, _id }) => {
    setDocumentos(prev => {
      return prev.map(x => {
        return {
          ...x,
          checked: x._id === _id ? !x.checked : x.checked
        }
      })
    })
  }

  return (
    <>
      <Row>
        <Col md={8}>
          <Row>
            <Col md={12} className='px-4'>
              <FormGroups.SeleccionarTodoFormGroup value={seleccionarTodos} onChange={seleccionarTodosClick} />
            </Col>
          </Row>
          <Row>
            <Col md={5}>
              <FormGroups.FechaFormGroup
                value={fecha}
                onChange={e => setFecha(e.target.value)}
                setFecha={v => setFecha(v)}
              />
            </Col>
            <Col md={2}>
              <Button onClick={clickConsultarHandler}>Consultar</Button>
            </Col>
          </Row>
        </Col>
      </Row>
      <Divider noMargin />
      {/* <Row>
        <Col md={12} className='px-4'>
          <FormGroups.SeleccionarTodoFormGroup
            value={seleccionarTodos}
            onChange={e => setSeleccionarTodos(e.target.value)}
          />
        </Col>
      </Row> */}
      <Row>
        <Col md={12} className='px-4 py-2'>
          <Table.ClientSide
            // ref={tablaRef}
            filas={documentos}
            headRows={[
              { label: '', width: 50, align: 'center' },
              { label: 'RUC' },
              { label: 'RAZ. SOCIAL' },
              { label: 'TIPO DOC.' },
              { label: 'NUM-SERIE' },
              { label: 'EMITIDA' },
              { label: 'ESTADO' }
            ]}
            rowTemplate={row => (
              <Table.Row hover key={row._id}>
                <Table.Cell align='center'>
                  <Form.Checkbox
                    checked={row.checked}
                    onChange={e => checkDocumentoChange({ e, _id: row._id })}
                    id={`flag-${row._id}`}
                    name={`flag-${row._id}`}
                    label=''
                  />
                </Table.Cell>
                <Table.Cell>{row.ruc || '--'}</Table.Cell>
                <Table.Cell>{row.razonSocial || '--'}</Table.Cell>
                <Table.Cell>{row.tipoDocumento || '--'}</Table.Cell>
                <Table.Cell>{`${row.serieDocumento}-${row.numeroDocumento}` || '--'}</Table.Cell>
                <Table.Cell>{row.fechaEmision || '--'}</Table.Cell>
                <Table.Cell>{row.estadoOSE ? EstadosOSE.__dictionary[row.estadoOSE].nombre : '--'}</Table.Cell>
              </Table.Row>
            )}
          />
        </Col>
      </Row>
      <Row>
        <Col md={12} className='px-4'>
          <Button disabled={documentos.length === 0} block onClick={enviarAOSEClick}>
            Enviar OSE
          </Button>
        </Col>
      </Row>
      {mostrarConfirmacionModal && (
        <ConfirmacionModal
          handleClose={e => setMostrarConfirmacionModal(false)}
          show={mostrarConfirmacionModal}
          ids={documentos.filter(x => x.checked).map(x => x._id)}
          refrescarTabla={clickConsultarHandler}
        />
      )}
    </>
  )
}

export default ResumenDiarioTab
